import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Select from 'react-select';
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";
export default class PurchaseOrderAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      projects: [],
      billingAddresses: [],
      dispatchAddresses: [],
      items: [],
      poNumber: "",
      poDate: "",
      customerId: "",
      projectId: "",
      billingAddressId: "",
      dispatchAddressId: "",
      status: "draft",
      customersDispatchAddress: [],
      customersBillingAddress: [],
      poItems: [
        {
          serialNumber: '',
          itemId: "",
          hsnCode: "",
          uom: "",
          quantity: "",
          rate: "",
          taxableValue: 0,
          gstValue: 0,
          totalValue: 0,
          pendingQuantity: 0,
        },
      ],
      loading: false,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      color: '',
      isEdit: false,
      poId: null,
      showLoading: true,
      itemSearchInput: "", // user input for filtering
      showDropdown: false,
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.fetchCustomers();
    await this.fetchItems();

    const poId = this.props.match?.params?.id;
    if (poId) {
      this.setState({ isEdit: true, poId });
      await this.fetchPurchaseOrder(poId);

      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    } else {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    }
  }

  // componentDidMount() {
  //   this.fetchCustomers();
  //   this.fetchItems().then(() => {
  //     const poId = this.props.match?.params?.id;
  //     if (poId) {
  //       this.setState({ isEdit: true, poId });
  //       this.fetchPurchaseOrder(poId);
  //     }
  //   });
  //   setTimeout(() => {
  //     this.setState({ loading: false })
  //   }, 1000)
  // }

  fetchCustomersBillingAddress = async (customerId) => {
    try {
      const res = await axios.get(`/address/${customerId}/c/b`);
      this.setState({ customersBillingAddress: res.data });
    } catch (error) {
      console.error("Error fetching billing address:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchCustomersDispatchAddress = async (customerId) => {
    try {
      const res = await axios.get(`/address/${customerId}/c/d`);
      this.setState({ customersDispatchAddress: res.data });
    } catch (error) {
      console.error("Error fetching dispatch address:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchCustomers = async () => {
    try {
      const res = await axios.get("/customer");
      this.setState({ customers: res.data });
    } catch (error) {
      console.error("Failed to fetch customers:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };

  fetchProjects = async (customerId) => {
    try {
      const res = await axios.get(`/project/customer/${customerId}`);
      this.setState({ projects: res.data });
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchAddresses = async (customerId) => {
    try {
      const res = await axios.get(`/address?customerId=${customerId}`);
      const billingAddresses = res.data.filter((a) => a.type === "billing");
      const dispatchAddresses = res.data.filter((a) => a.type === "dispatch");

      this.setState({
        billingAddresses,
        dispatchAddresses,
      });
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchItems = async () => {
    try {
      const res = await axios.get("/items");
      this.setState({ items: res.data });
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  // fetchPurchaseOrder = (id) => {
  //   // this.setState({ loading: true });
  //   // console.log("fetchPurchaseOrder", id);
  //   axios
  //     .get(`/purchaseOrders/${id}`)
  //     .then((res) => {
  //       const po = res.data;
  //       this.setState(
  //         {
  //           poNumber: po.poNumber,
  //           poDate: po.poDate,
  //           customerId: po.customerId,
  //           projectId: po.projectId,
  //           billingAddressId: po.billingAddressId,
  //           dispatchAddressId: po.dispatchAddressId,
  //           status: po.status,
  //           poItems: po.items.map((item) => ({
  //             serialNumber: item.serialNumber,
  //             itemId: item.itemId,
  //             hsnCode: item.hsnCode,
  //             uom: item?.uomData?.name || item.uom, // Get name from pre-fetched items
  //             quantity: item.quantity,
  //             rate: item.rate,
  //             taxableValue: item.taxableValue,
  //             gstValue: item.gstValue,
  //             totalValue: item.totalValue,
  //             pendingQuantity: item.pendingQuantity,
  //           })),
  //         },
  //         () => {
  //           this.fetchProjects(po.customerId);
  //           // this.fetchAddresses(po.customerId);
  //           this.fetchItems();
  //           this.fetchCustomersBillingAddress(po.customerId);
  //           this.fetchCustomersDispatchAddress(po.customerId);
  //           setTimeout(() => {
  //             this.setState({ loading: false })
  //           }, 3000)
  //         }
  //       );
  //     })
  //     .catch(() => {
  //       setTimeout(() => {
  //         this.setState({ loading: false })
  //       }, 1000)
  //     });
  // };


  fetchPurchaseOrder = async (id) => {
    // this.setState({ loading: true });
    try {
      const res = await axios.get(`/purchaseOrders/${id}`);
      const po = res.data;
      // Set form data from PO
      this.setState({
        poNumber: po.poNumber,
        poDate: po.poDate,
        customerId: po.customerId,
        projectId: po.projectId,
        billingAddressId: po.billingAddressId,
        dispatchAddressId: po.dispatchAddressId,
        status: po.status,
        poItems: po.items.map((item) => ({
          serialNumber: item.serialNumber,
          itemId: item.itemId,
          hsnCode: item.hsnCode,
          uom: item?.uomData?.name || item.uom,
          quantity: item.quantity,
          rate: item.rate,
          taxableValue: item.taxableValue,
          gstValue: item.gstValue,
          totalValue: item.totalValue,
          pendingQuantity: item.pendingQuantity,
        })),
      });
      // Wait for all dependent data to finish
      await Promise.all([
        this.fetchProjects(po.customerId),
        this.fetchItems(),
        this.fetchCustomersBillingAddress(po.customerId),
        this.fetchCustomersDispatchAddress(po.customerId),
      ]);
      this.setState({ showLoading: false })
    } catch (error) {
      console.error("Error fetching PO:", error);
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    }
  };


  handleCustomerChange = (e) => {
    const customerId = e.target.value;
    this.setState(
      {
        customerId,
        projectId: "",
        billingAddressId: "",
        dispatchAddressId: "",
        projects: [],
        billingAddresses: [],
        dispatchAddresses: [],
      },
      () => {
        if (customerId) {
          this.fetchProjects(customerId);
          // this.fetchAddresses(customerId);
          this.fetchCustomersBillingAddress(customerId);
          this.fetchCustomersDispatchAddress(customerId);
        }
      }
    );
  };

  handleProjectChange = (e) => {
    this.setState({ projectId: e.target.value });
  };

  handleBillingAddressChange = (e) => {
    this.setState({ billingAddressId: e.target.value });
  };

  handleDispatchAddressChange = (e) => {
    this.setState({ dispatchAddressId: e.target.value });
  };

  handlePoNumberChange = (e) => {
    this.setState({ poNumber: e.target.value });
  };

  handlePoDateChange = (e) => {
    this.setState({ poDate: e.target.value });
  };

  handlePoItemChange = (index, field, value) => {

    const poItems = [...this.state.poItems];
    poItems[index][field] = value;

    if (field === "itemId") {
      const selectedItem = this.state.items.find((i) => i.itemid === parseInt(value));
      // const selectedItem = this.state.items.find((i) => i.name === parseInt(value));
      if (selectedItem) {
        poItems[index].hsnCode = selectedItem.hsnCode || "";
        poItems[index].uom = selectedItem.uomData?.name || ""; // Store UOM name
      } else {
        poItems[index].hsnCode = "";
        poItems[index].uom = "";
      }
    }

    if (field === "quantity" || field === "rate" || field === "itemId") {
      const quantity = parseFloat(poItems[index].quantity) || 0;
      const rate = parseFloat(poItems[index].rate) || 0;
      const taxableValue = quantity * rate;
      const gstValue = taxableValue * 0.18;
      const totalValue = taxableValue + gstValue;
      poItems[index].taxableValue = taxableValue;
      poItems[index].gstValue = gstValue;
      poItems[index].totalValue = totalValue;
      poItems[index].pendingQuantity = quantity; // Initially pending quantity equals quantity
    }

    this.setState({ poItems });
  };

  addRow = () => {
    const poItems = [...this.state.poItems];
    poItems.push({
      serialNumber: '',
      // serialNumber: poItems.length + 1,
      itemId: "",
      hsnCode: "",
      uom: "",
      quantity: "",
      rate: "",
      taxableValue: 0,
      gstValue: 0,
      totalValue: 0,
      pendingQuantity: 0,
    });
    this.setState({ poItems });
  };

  removeRow = (index) => {
    const poItems = [...this.state.poItems];
    poItems.splice(index, 1);
    // Recalculate serial numbers
    poItems.forEach((item, idx) => {
      item.serialNumber = idx + 1;
    });
    this.setState({ poItems });
  };

  PurchaseOrderList = () => {
    this.props.history.push('/PurchaseOrderList')
  }

  validateForm = () => {
    const errors = {};
    if (!this.state.customerId) errors.customerId = "Customer is required";
    if (!this.state.projectId) errors.projectId = "Project is required";
    if (!this.state.billingAddressId) errors.billingAddressId = "Billing address is required";
    if (!this.state.dispatchAddressId) errors.dispatchAddressId = "Dispatch address is required";
    // if (!this.state.poNumber.trim()) errors.poNumber = "PO Number is required";
    const poNumber = this.state.poNumber.trim();
    // const poNumberRegex = /^\d{1,6}$/;

    // if (!poNumber) {
    //   errors.poNumber = "PO Number is required";
    // } else if (!poNumberRegex.test(poNumber)) {
    //   errors.poNumber = "PO Number must be 1 to 6 digits only";
    // }
    const poNumberRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~ ]{1,30}$/;

    if (!poNumber) {
      errors.poNumber = "PO Number is required";
    } else if (!poNumberRegex.test(poNumber)) {
      errors.poNumber = "PO Number must be 1 to 30 characters and can include letters, numbers, and special characters";
    }
    if (!this.state.poDate) errors.poDate = "PO Date is required";
    this.state.poItems.forEach((item, index) => {
      // debugger;
      if (!item.serialNumber) errors[`serialNumber_${index}`] = "Serial number is required";
      if (!item.itemId) errors[`itemId_${index}`] = "Item is required";
      if (!item.quantity < 0) errors[`quantity_${index}`] = "Quantity must be greater or equal to 0";
      if (!item.rate || item.rate <= 0) errors[`rate_${index}`] = "Rate must be greater than 0";
    });
    return errors;
  };

  onSubmit = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({
        errors,
        showToast: true,
        toastMessage: "Please fix validation errors",
        toastVariant: "danger",
        color: 'red',
        loading: false,
        showLoading: false
      });
      return;
    }

    const {
      customerId,
      projectId,
      billingAddressId,
      dispatchAddressId,
      poNumber,
      poDate,
      status,
      poItems,
      isEdit,
      poId,
    } = this.state;

    const payload = {
      customerId,
      projectId,
      billingAddressId,
      dispatchAddressId,
      poNumber,
      poDate,
      status,
      items: poItems,
    };


    const request = isEdit
      ? axios.put(`/purchaseOrders/${poId}`, payload)
      : axios.post("/purchaseOrders", payload);

    request
      .then(() => {
        this.setState({
          showToast: true,
          toastMessage: `Purchase Order ${isEdit ? "updated" : "created"} successfully!`,
          toastVariant: "success",
          color: 'green',
        },
        );

        if (!isEdit) {
          this.setState({
            customerId: "",
            projectId: "",
            billingAddressId: "",
            dispatchAddressId: "",
            poNumber: "",
            poDate: "",
            poItems: [
              {
                serialNumber: '',
                itemId: "",
                hsnCode: "",
                uom: "",
                quantity: "",
                rate: "",
                taxableValue: 0,
                gstValue: 0,
                totalValue: 0,
                pendingQuantity: 0,
              },
            ],
            errors: {},
          });
        }
        setTimeout(() => {
          this.setState({ loading: false, showLoading: false })
          this.PurchaseOrderList()
        }, 600)
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          toastMessage: error.response?.data?.message || "Error saving Purchase Order",
          toastVariant: "danger",
          color: 'red',
          loading: false
        });

      });
  };

  changeStatus = (newStatus) => {

    // Prevent status change if already pending
    if (this.state.status === "pending") return;

    this.setState({ loading: true });

    const payload = {
      customerId: Number(this.state.customerId),
      projectId: Number(this.state.projectId),
      billingAddressId: Number(this.state.billingAddressId),
      dispatchAddressId: Number(this.state.dispatchAddressId),
      poNumber: this.state.poNumber,
      poDate: this.state.poDate,
      status: newStatus,
      items: this.state.poItems.map(item => ({
        ...item,
        itemId: Number(item.itemId),
        serialNumber: Number(item.serialNumber),
        quantity: Number(item.quantity),
        rate: Number(item.rate),
        taxableValue: Number(item.taxableValue),
        gstValue: Number(item.gstValue),
        totalValue: Number(item.totalValue),
        pendingQuantity: Number(item.pendingQuantity),
      })),
    };

    // Use PUT instead of POST for status change if poId exists (edit)
    const isEdit = this.state.isEdit && this.state.poId;
    const request = isEdit
      ? axios.put(`/purchaseOrders/${this.state.poId}`, payload)
      : axios.post("/purchaseOrders", payload);  // fallback if poId doesn't exist

    request
      .then((response) => {
        const updatedState = {
          status: newStatus,
          showToast: true,
          toastMessage: `Purchase Order status changed to "${newStatus}"`,
          toastVariant: "success",
          color: "green",
        };

        // Set ID if this was a new record
        if (!isEdit) {
          updatedState.isEdit = true;
          updatedState.poId = response.data.id;
        }
        this.setState(updatedState);
        setTimeout(() => {
          this.setState({ loading: false })
          this.PurchaseOrderList()
        }, 600)
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error changing status",
          toastVariant: "danger",
          color: "red",
        });
      });
  };


  render() {
    const {
      customers,
      projects,
      items,
      poNumber,
      poDate,
      customerId,
      projectId,
      billingAddressId,
      dispatchAddressId,
      status,
      poItems,
      errors,
      loading,
      isEdit,
    } = this.state;



    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back">
                  <b>
                    {this.props?.location?.pathname?.includes('purchaseOrder-view')
                      ? "View"
                      : isEdit
                        ? "Update"
                        : "Add"} Purchase Order
                  </b>
                  <span style={{ cursor: 'pointer' }} onClick={() => this.PurchaseOrderList()}>
                    <i className="far fa-arrow-alt-circle-right"> Purchase Order List</i>
                  </span>
                </div>
              </Card.Header>
              <Card.Body style={{ marginBottom: '40px' }}>
                <Form>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formCustomer">
                        <Form.Label className="required">Customer</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={customerId}
                          onChange={this.handleCustomerChange}
                          isInvalid={!!errors?.customerId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Customer</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.customerId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={projectId}
                          onChange={this.handleProjectChange}
                          isInvalid={!!errors?.projectId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.projectId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formPoNumber">
                        <Form.Label className="required">PO Number</Form.Label>
                        <Form.Control
                          type="text"
                          value={poNumber}
                          placeholder="Enter PO number"
                          onChange={this.handlePoNumberChange}
                          isInvalid={!!errors?.poNumber}
                          disabled={status === "pending"}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.poNumber}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formPoDate">
                        <Form.Label className="required">PO Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={poDate}
                          onChange={this.handlePoDateChange}
                          isInvalid={!!errors?.poDate}
                          disabled={status === "pending"}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.poDate}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="formBillingAddress">
                        <Form.Label className="required">Billing Address</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={billingAddressId}
                          onChange={this.handleBillingAddressChange}
                          isInvalid={!!errors?.billingAddressId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Billing Address</option>
                          {this.state.customersBillingAddress.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.address}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.billingAddressId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formDispatchAddress">
                        <Form.Label className="required">Dispatch Address</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={dispatchAddressId}
                          onChange={this.handleDispatchAddressChange}
                          isInvalid={!!errors?.dispatchAddressId}
                          disabled={status === "pending"}
                        >
                          <option value="">Select Dispatch Address</option>
                          {this.state.customersDispatchAddress.map((a) => (
                            // {dispatchAddresses.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.address}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.dispatchAddressId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>Items</h5>
                  {poItems.map((item, index) => (
                    <Card key={index} className="mb-3">
                      <Card.Body>
                        <Row>
                          <Col md={2}>
                            <Form.Group controlId={`formSno${index}`}>
                              <Form.Label className="required">S.No</Form.Label>
                              <Form.Control type="text"
                                value={item.serialNumber}
                                placeholder="Enter S.no"
                                maxLength={5}
                                isInvalid={!!errors?.[`serialNumber_${index}`]}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const regex = /^\d{0,5}$/;

                                  if (regex.test(value)) {
                                    this.handlePoItemChange(index, "serialNumber", value);
                                  }
                                }}
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`serialNumber_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formItem${index}`}>
                              <Form.Label className="required">Item</Form.Label>
                              <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                options={items.map((i) => ({
                                  value: i.itemid,
                                  label: i.name
                                }))}
                                value={
                                  items.find((i) => i.itemid === item.itemId)
                                    ? {
                                      value: item.itemId,
                                      label: items.find((i) => i.itemid === item.itemId).name
                                    }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  this.handlePoItemChange(index, "itemId", selectedOption?.value || "")
                                }
                                isDisabled={status === "pending"}
                                placeholder="Select Item"
                                isSearchable={true}
                              />
                              {errors?.[`itemId_${index}`] && (
                                <div className="invalid-feedback d-block">
                                  {errors[`itemId_${index}`]}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group controlId={`formHsnCode${index}`}>
                              <Form.Label>HSN Code</Form.Label>
                              <Form.Control type="text" value={item.hsnCode} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group controlId={`formUom${index}`}>
                              <Form.Label>UOM</Form.Label>
                              <Form.Control type="text" value={item.uom} readOnly />
                            </Form.Group>
                          </Col>

                        </Row>
                        <Row>
                          <Col md={2}>
                            <Form.Group controlId={`formQuantity${index}`}>
                              <Form.Label className="required">Quantity</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.quantity}
                                placeholder="Enter quantity"
                                onChange={(e) => this.handlePoItemChange(index, "quantity", e.target.value)}
                                isInvalid={!!errors?.[`quantity_${index}`]}
                                disabled={status === "pending"}
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`quantity_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formRate${index}`}>
                              <Form.Label className="required">Rate</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.rate}
                                placeholder="Enter rate"
                                onChange={(e) => this.handlePoItemChange(index, "rate", e.target.value)}
                                isInvalid={!!errors?.[`rate_${index}`]}
                                disabled={status === "pending"}
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`rate_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formTaxableValue${index}`}>
                              <Form.Label>Taxable Value</Form.Label>
                              <Form.Control type="number" value={item.taxableValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formGstValue${index}`}>
                              <Form.Label>GST (18%)</Form.Label>
                              <Form.Control type="number" value={item.gstValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formTotalValue${index}`}>
                              <Form.Label>Total Value</Form.Label>
                              <Form.Control type="number" value={item.totalValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formPendingQuantity${index}`}>
                              <Form.Label>Pending Quantity</Form.Label>
                              <Form.Control type="number" value={item.pendingQuantity} readOnly />
                            </Form.Group>
                          </Col>
                        </Row>
                        {status !== "pending" && (
                          <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm mt-3 custom-add-button-cancel" onClick={() => this.removeRow(index)} >
                            Remove
                          </Button>
                        )}
                      </Card.Body>
                    </Card>
                  ))}
                  {status !== "pending" && (
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.addRow} >
                      Add Row
                    </Button>
                  )}
                  <hr />
                  {/* <p className="total-value">Total Value of All Items: ₹ <span className="amount-value">{poItems.reduce((sum, item) => sum + (parseFloat(item.totalValue) || 0), 0).toFixed(2)}</span></p> */}
                  <div>
                    <span className="status-btn">
                      {status !== "pending" && (
                        <Button variant='primary' className="px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={(e) => this.onSubmit(e)} >
                          Save as Draft
                        </Button>
                      )}
                    </span>
                    <span className="status-btn">
                      {status === "draft" && (
                        <Button variant='warning' className="px-4 py-2 rounded-pill shadow-sm custom-add-button-generate btn btn-primary" onClick={() => this.changeStatus("pending")} >
                          Mark as Pending
                        </Button>
                      )}
                    </span>
                    <span>
                      <Button variant='danger' className="px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={() => this.PurchaseOrderList()} >
                        Cancel
                      </Button>
                    </span>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader >
      </>
    );
  }
}
